import API from '../../shared/services/api-service';

export default (objPassword, env) => {
  return API.post('auth/update-password-recovery', objPassword, env);
};
